import { IConfig } from '@cian/config/shared';

export const isFileUploadButtonEnabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.FileUploadButton.Enabled'));
};
